/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {theme, themeV2, coloredScrollBar, pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- TABLE REPORT SECTION : STYLES --------------- ++++++++++ */
export default {
    tablereportsection: {
        width: '100%',
        height: '100%',
        background: 'white',
        minHeight: '300px',
        marginBottom: pxToEm(16),
        '& .tablereport': {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            marginBottom: pxToEm(35),
            '& .title': {
                fontSize: pxToEm(16),
                padding: pxToEm(24),
                paddingBottom: pxToEm(6),
            },
            '& .table': {
                width: '100%',
                height: '100%',
                overflowY: 'auto',
                extend: coloredScrollBar(themeV2.color.base.scrollbar),
                '& .name-tablefooter': {
                    bottom: 0,
                    position: 'relative',
                    width: '100%',
                },
                // '& .standardpagination': {
                //     // marginTop: pxToEm(20),
                // },
                '& .tableview': {
                    flex: 1,
                    '& table': {
                        marginBottom: pxToEm(20),
                    }
                }
            }
        },
        // TODO: Temp hover state, once approve apply it in component
        '& .listtable.type-nowrap': {
            '& .overflow': {
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline',
                    color: '#0C2483'
                }
            },
            '& .tooltip': {
                visibility: 'hidden'
            }
        }
    }
};
